export default __webpack_public_path__ + "static/media/rewind.c2734cb5.svg";